function updateQueryParams(key: string, values: string[], append?: boolean) {
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams

    if (append)
        values.forEach(param => {
            searchParams.append(key, param)
        })
    else
        searchParams.set(key, values[0])


    // Construct the updated URL
    const updatedUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}`

    window.location.href = updatedUrl
}

export default updateQueryParams